module.exports = __webpack_public_path__ + "videos/1.20b2e5f.mp4";